import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eb442bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dataApi" }
const _hoisted_2 = { style: {"width":"300px"} }
const _hoisted_3 = { class: "menu-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "menu-item-content" }

import Data from "./data.js";
import { ref, watch } from "vue";
import DocumentItem from "./details.vue";
import { useRouter, useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'menu',
  setup(__props) {

const defultActive = ref("/dataProduct/0/00");
// const parameterArr = ref("sum");
const router = useRouter();
const route = useRoute();
const parameterArr = ref();
const menuId = ref();
const menuItemId = ref();

// const handleOpen = (key: string, keyPath: string[]) => {
//   console.log(key, keyPath);
// };
// const handleClose = (key: string, keyPath: string[]) => {
//   console.log(key, keyPath);
// };

watch(
  () => route.params,
  (val: object) => {
    menuItemId.value = val.menuItemId;
    menuId.value = val.menuId;
  },
  { immediate: true, deep: true }
);
watch(
  () => route,
  (val: object) => {
    setTimeout(() => {
      defultActive.value = val.path;
    });
  },
  { immediate: true, deep: true }
);
const menuClick = (id: string) => {
  console.log(id, 1111111, "000");

  router.push(`/dataProduct/${id}/00`);
  parameterArr.value = [id, "00"];
};

const itemClick = (id: string, subItem: string) => {
  console.log(222);

  router.push(`/dataProduct/${id}/${subItem}`);
  parameterArr.value = [id, subItem];
};

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_menu, {
          "default-active": defultActive.value,
          class: "el-menu-vertical-demo",
          "text-color": "#454343",
          "unique-opened": "",
          "active-text-color": "#1e73f1"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Data), (item, index) => {
              return (_openBlock(), _createBlock(_component_el_sub_menu, {
                key: index,
                index: index + ''
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (menuClick(item.id))
                  }, [
                    _createElementVNode("img", {
                      class: "icon",
                      src: item.id === menuId.value ? item.colorIcon : item.icon,
                      alt: item.name
                    }, null, 8, _hoisted_5),
                    _createElementVNode("span", {
                      class: _normalizeClass({ active: item.id === menuId.value })
                    }, _toDisplayString(item.name), 3)
                  ], 8, _hoisted_4)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item_group, { style: {"background":"#fff"} }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (subItem, index) => {
                        return (_openBlock(), _createBlock(_component_el_menu_item, {
                          key: index,
                          index: `/dataProduct/${item.id}/${subItem.id}`,
                          onClick: ($event: any) => (itemClick(item.id, subItem.id))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["subItemName", { active: subItem.id === menuItemId.value }])
                            }, "- " + _toDisplayString(subItem.name), 3)
                          ]),
                          _: 2
                        }, 1032, ["index", "onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["index"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["default-active"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(DocumentItem, {
        menuData: _unref(Data),
        menuId: menuId.value,
        menuItemId: menuItemId.value,
        parameterArr: parameterArr.value
      }, null, 8, ["menuData", "menuId", "menuItemId", "parameterArr"])
    ])
  ]))
}
}

})